<template>
  <div class="row items-center">
    <div class="col-auto">
      <q-checkbox
        v-model="model"
        size="xs"
        color="secondary"
        class="full-width"
      />
    </div>
    <div
      class="q-ml-xs col text-caption ellipsis"
      :class="[
        model ? 'text-dark text-weight-medium' : 'text-grey text-weight-normal',
      ]"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Toogle",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      model: false,
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function () {
        this.model = this.value;
      },
    },

    model() {
      this.$emit("input", this.model);
    },
  },
};
</script>

<style lang="scss" scoped></style>
